import { Button, Menu, MenuItem } from '@material-ui/core';
import { useState } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PropTypes from 'prop-types';
import { exportDeploymentsCsv, exportDeploymentsPdf } from '../../utils/report-export';

export default function ExportButton({ invoiceData, metadata = {} }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportCsv = () => {
    if (invoiceData) {
      exportDeploymentsCsv(invoiceData, metadata);
      setAnchorEl(null);
    }
  };

  const handleExportPdf = () => {
    if (invoiceData) {
      exportDeploymentsPdf(invoiceData, metadata);
      setAnchorEl(null);
    }
  };

  return (
    <>
      <Button
        disabled={!invoiceData}
        variant="contained"
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
      >
        Export
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={handleExportPdf}>Export PDF</MenuItem>
        <MenuItem onClick={handleExportCsv}>Export CSV</MenuItem>
      </Menu>
    </>
  );
}

ExportButton.propTypes = {
  invoiceData: PropTypes.object,
  metadata: PropTypes.object
};
